export default "__VITE_ASSET__c8df6f7c__"